import { WifiOff } from '@/components/ui/icons';
import { useEffect, useState } from 'react';
import { Spinner } from '@/components/ui/Spinner';
import { useConnection } from '@/stores/realtime';

/** Shown when the real-time connection drops (after a short grace period to avoid flicker). */
export function ConnectionBanner() {
  const status = useConnection((s) => s.status);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === 'connected' || status === 'offline') {
      setVisible(false);
      return;
    }
    const t = window.setTimeout(() => setVisible(true), 1200);
    return () => window.clearTimeout(t);
  }, [status]);

  if (!visible) return null;
  return (
    <div role="status" className="z-20 flex animate-fade-in items-center justify-center gap-2 bg-warning px-3 py-1.5 text-sm font-semibold text-black">
      {navigator.onLine ? <Spinner size={14} /> : <WifiOff size={14} />}
      {navigator.onLine ? 'Connection lost — reconnecting…' : "You're offline. We'll reconnect when you're back."}
    </div>
  );
}
